<template style="">
  <div class="wrapper">
    <div id="landing-wrapper">
      <div id="landing-content">
        <h2 class="big-heading">Your productivity, all in one.</h2>
        <div>
          <router-link
            to="/register"
            class="button button-primary"
            id="landing-button"
          >
            Create Free Account</router-link
          >
        </div>
      </div>
      <div id="landing-content-mobile">
        <div id="hero-img-wrapper">
           <h2 class="big-heading-mobile">Your productivity, all in one.</h2>
          
          <img src="@/assets/learn.svg" alt="" id="hero-img" />
        </div>

        <div id="hero-button-wrapper">
          <router-link
            to="/register"
            class="button button-primary"
            id="landing-button"
          >
            Let's Get Started
          </router-link>
          <p>
            Already have an account?
            <router-link to="/login" class=""> Login </router-link>
          </p>
        </div>
      </div>
    </div>
    <div id="product-description">
      <h2 class="big-heading" id="screenshots-heading">The Product</h2>
      <p class="screenshot-wrapper">
        Kaado is the solution for all your productivity needs. You create
        different kind of flash cards for everything you need: learning cards,
        habit cards, reading list cards and many more. Kaado then presents these
        cards to you, whenever they are due, one at a time. No more being
        overwhelmed by your goals!
        <br />
        Check out how it works below.
      </p>

      <div class="screenshot-wrapper">
        <img src="@/assets/screenshots/e_habit.png" class="mock" alt="" />

        <div>
          <h3>Create your cards</h3>
          <p>
            Utilize Kaado's different types of cards to convert everything you
            want to do into flash cards: Learning materials, habits, todo's,
            your reading list, you name it. Each card type has the tools to
            configure the card just as you need it.
          </p>
        </div>
      </div>

      <div class="screenshot-wrapper">
        <div>
          <h3>Learn, do and enjoy one card at a time</h3>
          <p>
            Check out your card queue at any time: Kaado will present you with
            one specific card that's due next. That might be testing learn
            material, doing a small habit, or enjoying a fun quote you saved.
            Get it done (or skip it for now) and onto the next!
          </p>
        </div>

        <img
          src="@/assets/screenshots/q_learn_2.png"
          class="mock small-mock"
          alt=""
        />
      </div>

      <div class="screenshot-wrapper">
        <img src="@/assets/screenshots/q_other3.png" class="mock" alt="" />

        <div>
          <h3>Keep it fun</h3>
          <p>
            Productivity does not have to be dry! Store interesting stuff,
            pictures, quotes, art or even memes in Kaado - these cards will pop
            up inbetween the others and keep you productivity session
            entertaining.
            <br />
            You can use links, images and Markdown formatting to make your cards
            appealing and fun.
          </p>
        </div>
      </div>

      <div class="screenshot-wrapper">
        <div>
          <h3>Stay motivated</h3>
          <p>
            Keep track of your progress with detailed statistics and charts.
          </p>
        </div>
        <img src="@/assets/screenshots/s_screenshot.png" class="mock" alt="" />
      </div>

      <div class="screenshot-wrapper">
        <img src="@/assets/screenshots/s_dash.png" class="mock" alt="" />

        <div>
          <h3>Organize it your way</h3>
          <p>Create your own card decks and always know where to find them.</p>
        </div>
      </div>

      <div class="screenshot-wrapper">
        <router-link
          to="/register"
          class="button button-primary"
          id="landing-button"
        >
          Create Free Account</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
};
</script>
